import * as Yup from "yup";

import { Modal, OfficeButton } from "components";
import {
  PublishCommentOnDocument,
  PublishCommentOnDocumentVariables,
} from "_graphql/queries/kek/__generated__/PublishCommentOnDocument";

import CommentView from "components/cards/comment-view";
import { publishComment } from "_graphql/kek/queries/offers.kek";
import toast from "react-hot-toast";
import { useAppSearch } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { useKEKOffer } from "hooks/data/use-offers";
import { useMutation } from "@apollo/client";
import { useOfferComments } from "hooks/data/use-offer-comments";
import { wrapClick } from "utils";

const validationSchema = Yup.object().shape({});

export default function CommentContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const { offer } = useKEKOffer({
    offer_id: searchParams?.id || "",
  });
  const { comments, loading } = useOfferComments({
    offerId: searchParams?.id || "",
  });
  const [publishCommentMutation, { loading: publishing }] = useMutation<
    PublishCommentOnDocument,
    PublishCommentOnDocumentVariables
  >(publishComment, {
    refetchQueries: ["GetOfferComments"],
  });
  const form = useFormik<any>({
    initialValues: {
      message: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (variables, helpers) => {
      // submit comment
      publishCommentMutation({
        variables: {
          documentMessage: [variables.message],
          offerId: searchParams?.id || "",
        },
      })
        .then(({ data }) => {
          if (data?.publishCommentOnDocument) {
            toast.success("Comment published successfully");
            form.setFieldValue("message", "");
          }
        })
        .catch((err) => {
          toast.error("Failed to publish comment");
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="4xl"
      loading={loading}
      title={"Offer Comments for: " + offer?.offer_detail?.policy_number}
      description="Create and view comments on this offer"
      renderExtraContent={() => (
        <div className="divide-y divide-gray-100 dark:divide-white/10 w-full">
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900 dark:text-white">
              Insurance Company
            </dt>
            <dd className="flex text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 dark:text-gray-400">
              <span className="grow">
                {offer?.insurer?.insurer_company_name}
              </span>
            </dd>
          </div>
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900 dark:text-white">
              Class of business{" "}
            </dt>
            <dd className="flex text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 dark:text-gray-400">
              <span className="grow">
                {offer?.classofbusiness?.business_name}
              </span>
            </dd>
          </div>
        </div>
      )}
      renderActions={() => (
        <>
          <OfficeButton
            type="button"
            size="sm"
            // disabled={ }
            onClick={wrapClick(form.handleSubmit)}
          >
            Comment
          </OfficeButton>
        </>
      )}
    >
      <CommentView comments={comments} form={form} />
    </Modal>
  );
}
